import { TelMetrics } from '../telMetrics/index.js';

/**
 * @summary Sends telMetrics data on phone and text clicks
 */
export function telMetricsPhoneTextClick(_ref, option) {
  let {
    data
  } = _ref;
  TelMetrics.sendData(data, option);
  return {};
}
export default {
  telMetricsPhoneTextClick
};